import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import { useClickAway } from "react-use";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";

const NotificationSidebar = ({
  closeNotificationSidebar,
  notificationCount,
  notificationIsOpen,
}) => {
  const { data = [], apiCall } = useApi(false);
  const [state, setState] = useState(1);

  const changeHandler = (v) => {
    setState(v);
  };

  const notificationCountArr = (num) => {
    let arr = [];
    if (num > 0) {
      arr = Array.from({ length: num }, (_, index) => index);
    }
    return arr;
  };

  const notificationSidebarRef = useRef();

  useClickAway(notificationSidebarRef, () => {
    closeNotificationSidebar(false);
  });

  useEffect(() => {
    // getNotification
    apiCall({
      url: `${apiUrls.dmsService.getNotifications}`,
      method: "get",
      onSuccess: (data) => {
        console.log("notification data", data);
        // setStoreDropdownState(data);
      },
    });
  }, []);

  return (
    <div
      className="flex absolute top-[0px] left-[0px] overflow-auto"
      style={{ zIndex: "9999" }}
    >
      <>
        <div
          className="fixed bg-white"
          // animate={{ width: notificationIsOpen ? "280px" : "0px" }}
          // transition={{ duration: 0.4 }}
          ref={notificationSidebarRef}
          style={{
            right: "0px",
            top: "0px",
            width: "280px",
            height: "100vh",
            zIndex: "99999",
            boxShadow: "0px 0px 6px #00000029",
          }}
        >
          {/* Notification and Annoucement */}
          <div
            style={{
              width: "20px",
              position: "absolute",
              left: "-20px",
              top: "4px",
              // padding: '4px',
              // paddingRight: '6px',
            }}
            className="cursor-pointer rounded-s-md py-2 px-3 bg-[--textRed] text-white"
            onClick={closeNotificationSidebar}
          >
            <span className=" text-xl font-bold ">X</span>
          </div>
          <div
            className=" flex justify-between"
            style={{ borderBottom: "1px solid #D9D9D9" }}
          >
            <span
              className={
                state === 1
                  ? "border-b-4 text-2xl py-2 cursor-pointer hover:bg-sky-100"
                  : "text-2xl py-2 cursor-pointer hover:bg-sky-100"
              }
              onClick={() => changeHandler(1)}
              style={{ paddingRight: "36px", paddingLeft: "36px" }}
            >
              Notification
            </span>
            <span
              className={
                state === 2
                  ? "border-b-4 text-2xl py-2 cursor-pointer hover:bg-sky-100"
                  : "text-2xl py-2 cursor-pointer hover:bg-sky-100"
              }
              onClick={() => changeHandler(2)}
              style={{ paddingRight: "36px", paddingLeft: "36px" }}
            >
              Announcements
            </span>
          </div>

          <div className="mt-4 flex">
            {state === 1 && (
              <div className="overflow-auto" style={{ maxHeight: "93vh" }}>
                {data.length > 0 ? (
                  data.map((msg, ind) => {
                    return (
                      <div
                        key={ind}
                        className={`${
                          notificationCountArr(notificationCount).includes(ind)
                            ? "font-semibold text-[0.8rem] border-2"
                            : "border-2"
                        } px-6 mt-4 py-4 mcd-bg-color mcd-font-regular text-xl border-radius-6 border mx-6 rounded-md bg-slate-100`}
                      >
                        <span className="">{msg?.text || ""}</span>
                      </div>
                    );
                  })
                ) : (
                  <div className="flex justify-center items-center mt-6 text-2xl">
                    Loading...
                  </div>
                )}
              </div>
            )}
            {state === 2 && (
              <div className="px-6 py-2 mcd-bg-color mcd-font-regular text-xl border-radius-6">
                Announcements
              </div>
            )}
          </div>
        </div>
      </>
    </div>
  );
};

export default NotificationSidebar;
